var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobCase = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 17,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#7D7D7D",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.606 2.294H1.693C.95 2.294.358 2.91.358 3.657V7.53c0 .263.175.494.428.566L8.212 10.2a3.434 3.434 0 0 0 1.875 0l7.426-2.104a.588.588 0 0 0 .428-.566V3.657c0-.747-.592-1.363-1.335-1.363zm0 1.175.04.007c.064.02.117.09.117.18v3.431L9.764 9.071l-.174.042c-.35.07-.711.056-1.056-.042L1.537 7.087v-3.43c0-.11.075-.188.156-.188h14.913z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.98 7.331c.298 0 .544.221.583.508l.006.08v6.506c0 1.173-.889 2.141-2.022 2.214l-.137.004H2.89c-1.152 0-2.085-.923-2.155-2.078l-.004-.14V7.92a.589.589 0 0 1 1.173-.08l.006.08v6.506c0 .545.39.985.88 1.038l.1.005h12.52c.502 0 .924-.406.975-.935l.005-.108V7.92c0-.325.264-.588.59-.588zM10.542.357c.719 0 1.3.564 1.359 1.273l.005.12v.744a.589.589 0 0 1-1.174.08l-.005-.08V1.75c0-.104-.062-.185-.138-.21l-.047-.007H7.617c-.08 0-.156.064-.178.158l-.007.06v.744a.589.589 0 0 1-1.174.08l-.005-.08V1.75c0-.723.543-1.326 1.245-1.387l.119-.005h2.925z"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobCase);
export default ForwardRef;